import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminLayout } from './components/AdminLayout';
import { AuthProvider } from './hooks/useAuth';
import AdminDashboard from './pages/AdminDashboard';
import AdminSection from './pages/AdminSection';
import Login from './pages/Login';
import AboutEditor from './pages/AboutEditor';

function App() {
  return <AuthProvider><Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/admin" element={<AdminLayout />}>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<AdminDashboard />} />
      <Route path="products" element={<AdminSection section="Products" />} />
      <Route path="news" element={<AdminSection section="News" />} />
      <Route path="gallery" element={<AdminSection section="Gallery" />} />
      <Route path="partners" element={<AdminSection section="Partners" />} />
      <Route path="team" element={<AdminSection section="Team" />} />
      <Route path="inquiries" element={<AdminSection section="Inquiries" />} />
      <Route path="messages" element={<AdminSection section="Messages" />} />
      <Route path="users" element={<AdminSection section="Users" />} />
        <Route path="about" element={<AboutEditor />} />
        <Route path="feedback" element={<AdminSection section="Feedback" />} />
    </Route>
    <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
  </Routes></AuthProvider>;
}

export default App;
